<template>
  <div>
    <sweet-modal ref="modal" class="vld-parent" hide-close-button>
      <loading :active="savingTemplate" :is-full-page="false" />
      <input
        class="form-control rename-input"
        type="text"
        v-model="newTemplateName"
      />
      <template #button>
        <button class="btn btn-default right-margin" @click="close">
          {{ $t('modals.close_button') }}
        </button>
        <button
          class="btn btn-primary"
          id="btn-rename-template"
          @click="renameTemplate"
        >
          {{ $t('template.rename') }}
        </button>
      </template>
    </sweet-modal>

    <sweet-modal ref="conflictModal" icon="error" hide-close-button>
      <p>
        <StrongI18n
          keypath="modals.name_exists"
          :values="{propName: conflictingName}"
        />
      </p>
      <template #button>
        <button class="btn btn-default right-margin" @click="close">
          {{ $t('modals.close_button') }}
        </button>
        <button
          id="btn-rename-abort"
          class="btn btn-primary"
          @click="onRenameConflictContinue"
        >
          {{ $t('modals.cancel_button') }}
        </button>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import Loading from 'vue-loading-overlay';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'RenameTemplateModal',
  components: {
    SweetModal,
    Loading,
    StrongI18n
  },
  data() {
    return {
      newTemplateName: '',
      selectedTemplate: {}
    };
  },
  computed: {
    ...mapState({
      savingTemplate: state => state.savingTemplate,
      success: state => state.success,
      conflict: state => state.conflict
    }),
    conflictingName() {
      return this.conflict ? this.conflict.name : '';
    }
  },
  methods: {
    ...mapMutations(['setSuccess']),
    ...mapActions(['doRenameTemplate']),
    open(template) {
      this.setSuccess(false);
      this.selectedTemplate = template;
      this.newTemplateName = template.name;
      this.$refs.modal.open();
    },
    onRenameConflictContinue() {
      this.setSuccess(false);
      this.$store.commit('setConflict', {status: false});
      this.resetData();
    },
    renameTemplate() {
      const payload = {
        originalTemplate: this.selectedTemplate,
        newTemplateName: this.newTemplateName
      };
      this.doRenameTemplate(payload);
    },
    resetData() {
      this.newTemplateName = '';
      this.selectedTemplate = {};
    },
    close() {
      this.$refs.modal.close();
      this.$refs.conflictModal.close();
    }
  },
  watch: {
    success(newValue) {
      if (newValue === true) {
        this.$refs.modal.close();
        this.$refs.conflictModal.close();
        this.resetData();
      }
    },
    conflict(newValue) {
      if (!newValue || !newValue.status) {
        this.$refs.conflictModal.close();
      } else if (newValue.kind === 'rename') {
        this.$refs.modal.close();
        this.$refs.conflictModal.open();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
.rename-input {
  margin-top: 18%;
}
</style>
